
jQuery(function($) {

    $(document).ready(function() {
        $(window).scroll(function() {
            if ($(this).scrollTop() > 0) {
                $('.header').addClass('header--active');
            } else {
                $('.header').removeClass('header--active');
            }
        });
    });


    $(function(){
        var button = $('.homeintro__link > a');
        var bottleItems = $('.homeintro__bottleitem');
        button.hover(function(){
            var button_data = $(this).data('bottle');
            var matchingBottleItem = $('.homeintro__bottleitem[data-bottle="' + button_data + '"]');
            bottleItems.removeClass('active');
            matchingBottleItem.addClass('active');
        }, function() { 
            bottleItems.removeClass('active');
            $('.homeintro__bottleitem[data-bottle="bottle1"]').addClass('active');
        });
    });



    $(function(){
        var fitler_toggle = $('.productfilter__title');
        fitler_toggle.click(function(){
            var browser_width = window.innerWidth;
            if(browser_width < 992){
                $(this).toggleClass('productfilter__title--active');
                $(this).siblings().slideToggle();
            }
        });
    });
    

    $(function(){
        $(".banner__view").click(function() {
            var offset = $(".productsingle").offset().top;
            $("html, body").animate({
                scrollTop: offset
            }, "slow");
            return false;
        });
    });



});